import React from 'react'
import { object, string, oneOfType } from 'prop-types'
import MobileHeader from './MobileHeader'
import HeaderView from './HeaderView'
import ContentView from './ContentView'

const MobileContent = ({ containerClasses, headerBarProps, headerProps, contentViewProps }) => (
  <div className='ad-filter__wrapper'>
    <div className='ad-filter__mobile-container'>
      <MobileHeader {...headerBarProps} />
      <div className={containerClasses}>
        <HeaderView {...headerProps} />
        <ContentView {...contentViewProps} />
      </div>
    </div>
  </div>
)

MobileContent.propTypes = {
  containerClasses: string,
  headerBarProps: object,
  headerProps: object,
  contentViewProps: object,
  itemLabel: oneOfType([string, object])
}

export default MobileContent